module.exports = __webpack_public_path__ + "static/img/label-02.6c8d84d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/kerry/label-02.png
// module id = MtAv
// module chunks = 150